<page-title [title]="titles[0]"></page-title>
<p>Mantenha seus dados atualizados.</p>

<ng-container *ngIf="showWarningMessage">
  <page-alert *ngIf="locationIsEmpty(location) && checkIfIsFirstAcess()" message="
   <h4>Olá, Seja bem vindo(a). Para uma melhorar experiencia: </h1>
    <li>📌 Complete seu <strong>perfil</strong></li>
    <li>📍 Defina sua <strong>localização</strong></li>
    <li>⏰ Configure seu <strong>horário de atendimento</strong></li>" alertClass="alert-warning">
</page-alert>

<page-alert *ngIf="locationIsEmpty(location) && !checkIfIsFirstAcess()" message="
   <h4>Para uma melhorar experiencia: </h1>
    <li>📍 Defina sua <strong>localização</strong></li>
    <li>⏰ Configure seu <strong>horário de atendimento</strong></li>" alertClass="alert-warning">
</page-alert>
</ng-container>


<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">

  <mat-tab label="Perfil">

    <ng-template matTabContent>
      <organization-registration mode="UPDATE"></organization-registration>
    </ng-template>
  </mat-tab>

  <mat-tab label="Localização" [disabled]="checkIfIsFirstAcess()">
    <ng-template mat-tab-label>
      <span [matTooltip]="checkIfIsFirstAcess() ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Localização
      </span>
    </ng-template>

    <organization-location mode="UPDATE" [location]="location"
      (onUpdateLocation)="setLocation($event)"></organization-location>

  </mat-tab>

  <mat-tab label="Horário de Atendimento" [disabled]="checkIfIsFirstAcess() || locationIsEmpty(location)">
    <ng-template mat-tab-label>
      <span [matTooltip]="checkIfIsFirstAcess() || locationIsEmpty(location) ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Horário de Atendimento
      </span>
    </ng-template>
    <ng-template matTabContent>
      <opening-hours (onUpdateLocation)="setLocation($event)" [location]="location" mode="UPDATE">
      </opening-hours>
    </ng-template>
  </mat-tab>
</mat-tab-group>